import { render, staticRenderFns } from "./layEmpty.vue?vue&type=template&id=566c89c0"
import script from "./layEmpty.vue?vue&type=script&lang=js"
export * from "./layEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports